import { createContext } from 'react'

import { IPollFormActions } from 'actions/pollform'

import { IPollFormState, initialPollFormState } from '../types/context'

export const PollFormContext = createContext<{pollForm: IPollFormState; pollFormDispatch: React.Dispatch<IPollFormActions>}>({pollForm: initialPollFormState, pollFormDispatch: () => null})